import { t } from '@lingui/core/macro';
import { Table, Alert, Box } from '@pocketlaw/tetris';
import { SearchResultTableBody } from './SearchResultsTableBody';
import { SearchResultsTableHead } from './SearchResultsTableHead';
import { TableContextProvider } from './TableContextProvider';
import { useSearchContext } from '../SearchProvider';
import { SearchResultsNoMatch } from '../SearchResultsNoMatch';
import { SearchResultsPagination } from '../SearchResultsPagination';
import { SearchTableColumnToggle } from '../SearchTableColumnToggle';
import { TableContainer } from './styled';
export function SearchResultsTable(props) {
    const { results = [], loading, error, totalHitsCount = 0, actions, filters, dense = false, withoutBorder = false, } = props;
    const { values, setOrderBy } = useSearchContext();
    const { orderBy, limit, columns } = values;
    const [sortId, sortOrder] = orderBy ? Object.entries(orderBy)[0] : [];
    const resultCount = results.length;
    const noResults = resultCount === 0 && !loading;
    const loadingColumns = columns.filter((col) => col.active).length;
    const handleSort = (newSortId, newSortState) => {
        if (newSortId) {
            setOrderBy({ [newSortId]: newSortState });
        }
    };
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>);
    }
    return (<TableContextProvider results={results} actions={actions}>
      <TableContainer>
        <Box gap="lg" alignItems="center">
          {filters}
          <Box ml="auto" gap="sm" alignSelf="flex-end">
            <SearchResultsPagination disabled={loading} totalCount={totalHitsCount} limit={limit}/>
            <SearchTableColumnToggle />
          </Box>
        </Box>

        {noResults && <SearchResultsNoMatch />}

        {!noResults && (<Table border={!withoutBorder} dense={dense} sortId={sortId} sortOrder={sortOrder} onSort={handleSort} loading={loading} loadingColumns={loadingColumns} loadingRows={limit}>
            <SearchResultsTableHead />
            <SearchResultTableBody />
          </Table>)}
      </TableContainer>
    </TableContextProvider>);
}
